import { render, staticRenderFns } from "./CourseRules.vue?vue&type=template&id=0796cbf1&scoped=true"
import script from "./CourseRules.vue?vue&type=script&lang=js"
export * from "./CourseRules.vue?vue&type=script&lang=js"
import style0 from "./CourseRules.vue?vue&type=style&index=0&id=0796cbf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0796cbf1",
  null
  
)

export default component.exports